import * as React from 'react';
import { observer } from 'mobx-react';

import ModalReactions from '../../../../../../Modal/ModalReactions';
import LearningCollectionDescriptionModal, { Props } from './LearningCollectionDescriptionModal';

const LearningCollectionDescription: React.FC<Props> = (props) => (
  <>
    <LearningCollectionDescriptionModal {...props} />
    <ModalReactions store={props.modalStore} />
  </>
);

export default observer(LearningCollectionDescription);
